import React, { Component } from 'react';
import './EndOfPage.css';
import PropTypes from 'prop-types';

class EndOfPage extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  render() {
    const { t } = this.context;
    return (
      <div className="divisionLine">
        <span className="vs">{t('engagement.endOfPage')}</span>
      </div>
    );
  }
}

export default EndOfPage;



// WEBPACK FOOTER //
// ./src/Components/EndOfPage/EndOfPage.js